if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.addEventListener(
          'pointerup',
          (event) => {
            if (event.pointerType !== 'mouse') return;
            if (
              event.target.closest(
                '.product-media-modal__content, .product-media-modal__nav, .product-media-modal__toggle'
              )
            ) {
              event.stopImmediatePropagation();
            }
          },
          true
        );

        this.querySelectorAll('[data-modal-nav]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.navigate(Number(button.dataset.modalNav));
          });
        });

        this.addEventListener('keyup', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'ArrowLeft') this.navigate(-1);
          if (event.code === 'ArrowRight') this.navigate(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const items = this.mediaItems;

        items.forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia =
          (mediaId && this.querySelector(`.product-media-modal__content > [data-media-id="${mediaId}"]`)) ||
          items[0];

        if (!activeMedia) return;

        this.activateMedia(activeMedia);
      }

      activateMedia(activeMedia) {
        this.mediaItems.forEach((element) => {
          element.classList.remove('active');
        });

        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavVisibility();
      }

      navigate(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;

        const currentIndex = items.findIndex((element) => element.classList.contains('active'));
        const nextIndex = (currentIndex + direction + items.length) % items.length;
        this.activateMedia(items[nextIndex]);
      }

      updateNavVisibility() {
        const hasMultiple = this.mediaItems.length > 1;
        this.querySelectorAll('[data-modal-nav]').forEach((button) => {
          button.hidden = !hasMultiple;
        });
      }
    }
  );
}
